import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics.service/analytics.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.less']
})
export class NewsComponent implements OnInit {
 
  constructor(analyticsService:AnalyticsService) {
    analyticsService.eventEmitter("read_news","News","load","NewsPage");
   }

  ngOnInit(): void {
  }

}
